import { ref, computed, nextTick, onMounted, onUnmounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a4eca53c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "echarts-content"
};
const _hoisted_2 = {
  class: "filter-new-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "reason-content"
}, null, -1));
const _hoisted_4 = {
  class: "filter-content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "结算货币：", -1));
const _hoisted_6 = {
  key: 0,
  id: "canvasReven"
};
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, GridComponent,
// 数据集组件
DatasetComponent,
// 内置数据转换器组件 (filter, sort)
TransformComponent, LegendComponent, DataZoomComponent,
// 标记线组件（分成变更指示线依赖）
MarkLineComponent } from 'echarts/components';
import { LabelLayout, UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import { selectTrendChart, withMinimumLoading } from '@/views/revenueKanbanManageNew/data/revenueDataService';
import Empty from '@/components/Empty.vue';
// 注册必须的组件
export default /*#__PURE__*/_defineComponent({
  __name: 'EchartsContent',
  setup(__props, {
    expose
  }) {
    echarts.use([TitleComponent, TooltipComponent, GridComponent, DatasetComponent, TransformComponent, LineChart, LabelLayout, UniversalTransition, CanvasRenderer, LegendComponent, DataZoomComponent, MarkLineComponent]);
    // 定义英文到中文的映射关系
    const enToZh = {
        avgBuyer: '付费人均付费次数',
        buyerCount: '付费用户数',
        cnyAvgRevenue: '人均客单价(CNY)',
        cnyAvgRevenueBuyer: '付费人均付费(CNY)',
        cnyRevenue: '总收入(CNY)',
        cnySales: '总销售额(CNY)',
        firstBuyerCount: '首次付费用户',
        firstBuyerRatio: '首次付费占比',
        orderCount: '总订单',
        refundAmount: '退费金额',
        refundOrderCount: '退费订单数',
        usdAvgRevenue: '人均客单价(USD)',
        usdAvgRevenueBuyer: '付费人均付费(USD)',
        usdRevenue: '总收入(USD)',
        usdSales: '总销售额(USD)'
      },
      targetListUsd = [{
        label: '总销售额(USD)',
        value: 'usdSales'
      }, {
        label: '总收入(USD)',
        value: 'usdRevenue'
      }, {
        label: '人均客单价(USD)',
        value: 'usdAvgRevenue'
      }, {
        label: '付费人均付费(USD)',
        value: 'usdAvgRevenueBuyer'
      }, {
        label: '付费用户数',
        value: 'buyerCount'
      }, {
        label: '总订单',
        value: 'orderCount'
      }, {
        label: '退费订单数',
        value: 'refundOrderCount'
      }, {
        label: '退费金额',
        value: 'refundAmount'
      }, {
        label: '首次付费用户',
        value: 'firstBuyerCount'
      }, {
        label: '首次付费占比',
        value: 'firstBuyerRatio'
      }, {
        label: '付费人均付费次数',
        value: 'avgBuyer'
      }],
      targetListCny = [{
        label: '总销售额(CNY)',
        value: 'cnySales'
      }, {
        label: '总收入(CNY)',
        value: 'cnyRevenue'
      }, {
        label: '人均客单价(CNY)',
        value: 'cnyAvgRevenue'
      }, {
        label: '付费人均付费(CNY)',
        value: 'cnyAvgRevenueBuyer'
      }, {
        label: '付费用户数',
        value: 'buyerCount'
      }, {
        label: '总订单',
        value: 'orderCount'
      }, {
        label: '退费订单数',
        value: 'refundOrderCount'
      }, {
        label: '退费金额',
        value: 'refundAmount'
      }, {
        label: '首次付费用户',
        value: 'firstBuyerCount'
      }, {
        label: '首次付费占比',
        value: 'firstBuyerRatio'
      }, {
        label: '付费人均付费次数',
        value: 'avgBuyer'
      }];
    // 定义响应式数据
    const xData = ref([]),
      // X轴数据
      selectedList = ref([]),
      // 选中的指标列表
      seriesData = ref([]),
      // 图表系列数据
      currency = ref(1),
      // 货币类型：1-美元，2-人民币
      echartType = ref(1),
      // 图表类型：1-趋势图，2-堆积图
      searchForm = ref({}),
      // 搜索表单数据
      loading = ref(false),
      // 加载状态
      groupValue = ref(['dbt_id', 'pay_chnl']),
      // 分组维度
      targetValue = ref([]),
      // 选中的目标指标
      echartData = ref(),
      // 图表原始数据
      targetList = ref(targetListUsd),
      // 当前显示的指标列表
      shareChangeList = ref([]); // 分成变更列表
    // 是否单选一款产品（多选/全选时为 false）
    const isSingleProduct = computed(() => {
      var _searchForm$value$dbt, _searchForm$value$dbt2;
      return ((_searchForm$value$dbt = (_searchForm$value$dbt2 = searchForm.value.dbtIdList) === null || _searchForm$value$dbt2 === void 0 ? void 0 : _searchForm$value$dbt2.length) !== null && _searchForm$value$dbt !== void 0 ? _searchForm$value$dbt : 0) === 1;
    });
    // 是否展示分成变更标记：单选一款 iOS 产品（iOS 由后端判定——非 iOS 时 shareChangeList 返回空）
    const showShareChange = computed(() => isSingleProduct.value && shareChangeList.value.length > 0);
    // 分成变更样式常量：按变化方向取色（上升=橙色系，下降=蓝色系）
    const SHARE_STYLE = {
      up: {
        line: '#D97706',
        tag: '#F97316',
        reasonBg: '#FFF7ED',
        reasonText: '#D98660'
      },
      down: {
        line: '#4B5563',
        tag: '#3B82F6',
        reasonBg: '#EFF6FF',
        reasonText: '#315EDC'
      }
    };
    const getShareStyle = isUp => isUp ? SHARE_STYLE.up : SHARE_STYLE.down;
    // InfoCircleOutlined 图标（tooltip 为 HTML 字符串，用内联 SVG，fill 跟随区域文字色）
    const INFO_ICON_SVG = '<svg viewBox="64 64 896 896" width="14" height="14" fill="currentColor" style="flex-shrink:0;margin-right:6px;">' + '<path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path>' + '<path d="M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"></path>' + '</svg>';
    // tooltip 通过 innerHTML 渲染，后端文本必须转义，避免 XSS
    const escapeHtml = s => String(s !== null && s !== void 0 ? s : '').replace(/[&<>"']/g, c => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[c]);
    // 从接口响应解析分成变更数据：后端把变更内嵌在每个趋势点的 divideChange 字段里，未变更时为 null
    const resolveShareChange = res => {
      const list = (res === null || res === void 0 ? void 0 : res.data) || [];
      return list.filter(item => {
        var _item$divideChange;
        return (item === null || item === void 0 || (_item$divideChange = item.divideChange) === null || _item$divideChange === void 0 ? void 0 : _item$divideChange.beforeDivide) && item.divideChange.afterDivide;
      }).map(item => {
        const {
          beforeDivide,
          afterDivide,
          reason
        } = item.divideChange;
        return {
          paymentDate: item.paymentDate,
          beforeDivide,
          afterDivide,
          isUp: parseInt(afterDivide) > parseInt(beforeDivide),
          reason
        };
      });
    };
    // 构建分成变更指示线 series（独立隐藏 series，不随指标勾选变化）
    const buildShareChangeSeries = () => ({
      name: '__shareChange__',
      type: 'line',
      data: [],
      silent: true,
      markLine: {
        symbol: 'none',
        data: shareChangeList.value.map(c => {
          const color = getShareStyle(c.isUp).line;
          return {
            xAxis: c.paymentDate,
            lineStyle: {
              color,
              type: 'dashed',
              width: 1
            },
            label: {
              show: true,
              position: 'end',
              formatter: `分成变更(${c.afterDivide})`,
              color,
              fontSize: 12
            }
          };
        })
      }
    });
    // 构建分成变更悬浮卡片 HTML
    const buildShareChangeCard = c => {
      const {
        tag: tagColor,
        reasonBg,
        reasonText
      } = getShareStyle(c.isUp);
      return `<div style="margin-bottom:8px;padding:8px;border-radius:4px;background:${reasonBg};color:${reasonText};">` + '<div style="display:flex;align-items:center;margin-bottom:4px;">' + INFO_ICON_SVG + '<span>分成变更：</span>' + `<span style="display:inline-flex;align-items:center;height:20px;padding:0 8px;border-radius:4px;color:#fff;font-size:12px;background:${tagColor};">${escapeHtml(c.beforeDivide)} ➔ ${escapeHtml(c.afterDivide)}</span>` + '</div>' + '<div style="display:flex;align-items:center;padding-left:20px;">' + '<span>变更原因：</span>' + `<span>${escapeHtml(c.reason)}</span>` + '</div>' + '</div>';
    };
    // 创建图表的方法
    const createChart = () => {
        if (!document.getElementById('canvasReven')) {
          return false;
        }
        // 销毁之前的图表实例
        echarts.dispose(document.getElementById('canvasReven'));
        const chartDom = document.getElementById('canvasReven'),
          myChart = echarts.init(chartDom);
        // 分成变更指示线：单选 iOS 产品时追加一条独立 series 承载 markLine
        const series = [...seriesData.value];
        if (showShareChange.value) {
          series.push(buildShareChangeSeries());
        }
        // 配置图表选项
        const options = {
          tooltip: {
            trigger: 'axis',
            enterable: true,
            // 自定义提示框内容
            formatter: function (params) {
              var _echartData$value$par;
              let str = `<div style="margin-bottom: 8px;">${params[0].name}</div>`;
              // 分成变更日期：卡片顶部优先展示结构化变更信息
              if (showShareChange.value) {
                const change = shareChangeList.value.find(c => c.paymentDate === params[0].name);
                if (change) str += buildShareChangeCard(change);
              }
              str += `<div style="max-height: 400px;overflow: auto">`;
              params.forEach(item => {
                str += `<div style="display: flex;align-items: center;justify-content: space-between"><span>${item.marker}${item.seriesName}</span><span style="font-weight: bold;margin-left: 20px;">${item.value || item.value === 0 ? item.value : '-'}</span></div>`;
              });
              // 处理分组数据
              if (echartData.value && (_echartData$value$par = echartData.value[params[0].dataIndex]) !== null && _echartData$value$par !== void 0 && _echartData$value$par.groupingData) {
                var _echartData$value$par2;
                (_echartData$value$par2 = echartData.value[params[0].dataIndex]) === null || _echartData$value$par2 === void 0 || (_echartData$value$par2 = _echartData$value$par2.groupingData) === null || _echartData$value$par2 === void 0 || _echartData$value$par2.forEach(item => {
                  var _Object$keys;
                  (_Object$keys = Object.keys(item)) === null || _Object$keys === void 0 || _Object$keys.forEach(key => {
                    if (key !== 'groupName' && key !== 'groupingData' && key !== 'paymentDate' && targetValue.value.includes(key)) {
                      var _params$filter, _params$;
                      str += `<div style="display: flex;align-items: center;justify-content: space-between"><span>${((_params$filter = params.filter(i => i.seriesName === enToZh[key])) === null || _params$filter === void 0 || (_params$filter = _params$filter[0]) === null || _params$filter === void 0 ? void 0 : _params$filter.marker) || ((_params$ = params[0]) === null || _params$ === void 0 ? void 0 : _params$.marker)}${item.groupName}_${enToZh[key]}</span><span style="font-weight: bold;margin-left: 20px;">${item[key]}</span></div>`;
                    }
                  });
                });
              }
              str += '</div>';
              return str;
            }
          },
          color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#fd7f82', '#ffa748'],
          legend: {
            data: selectedList.value,
            top: '93%'
          },
          grid: {
            left: '.5%',
            right: '2.5%',
            bottom: '10%',
            top: 24,
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xData.value
          },
          yAxis: {
            type: 'value'
          },
          series: series
        };
        myChart.resize();
        myChart.clear();
        myChart.setOption(options);
        loading.value = false;
      },
      // 获取图表数据
      getData = async (searchObj = {}) => {
        var _Object$keys2;
        if ((_Object$keys2 = Object.keys(searchObj)) !== null && _Object$keys2 !== void 0 && _Object$keys2.length) {
          searchForm.value = searchObj;
        }
        // 构建请求参数
        let params = {
          groupDimensionList: groupValue.value
        };
        // 过滤有效的搜索条件
        Object.keys(searchForm.value).forEach(item => {
          var _searchForm$value$ite;
          if (searchForm.value[item] || searchForm.value[item] && (_searchForm$value$ite = searchForm.value[item]) !== null && _searchForm$value$ite !== void 0 && _searchForm$value$ite.length) {
            params = {
              ...params,
              [item]: searchForm.value[item]
            };
          }
        });
        loading.value = true;
        try {
          // 调用接口获取数据
          const res = await withMinimumLoading(selectTrendChart(params));
          const {
            data,
            code
          } = res;
          if (code === '0') {
            if (data !== null && data !== void 0 && data.length) {
              echartData.value = data;
              handleData(data);
              shareChangeList.value = resolveShareChange(res);
            } else {
              xData.value = [];
              shareChangeList.value = [];
            }
          } else {
            loading.value = false;
          }
        } catch (e) {} finally {
          loading.value = false;
        }
      },
      // 处理图表数据
      handleData = data => {
        // 清空之前的数据
        seriesData.value = [];
        xData.value = [];
        selectedList.value = [];
        if (data !== null && data !== void 0 && data.length) {
          var _selectedList$value$f;
          // 处理选中的指标列表
          selectedList.value = Object.keys(data[0]);
          selectedList.value.splice(selectedList.value.indexOf('paymentDate'), 1);
          // 根据货币类型过滤指标
          selectedList.value = (_selectedList$value$f = selectedList.value.filter(i => !i.includes(currency.value === 1 ? 'cny' : 'usd'))) === null || _selectedList$value$f === void 0 ? void 0 : _selectedList$value$f.filter(item => targetValue.value.includes(item));
          // 构建图表系列数据
          let arr = selectedList.value.map(item => {
            if (echartType.value === 1) {
              // 趋势图配置
              return {
                name: item,
                type: 'line',
                data: []
              };
            } else {
              // 堆积图配置
              return {
                name: item,
                type: 'line',
                stack: 'Total',
                areaStyle: {},
                data: []
              };
            }
          });
          // 处理X轴和数据
          data.forEach(item => {
            xData.value = [...xData.value, item.paymentDate];
            arr.forEach(j => {
              j.data = [...j.data, item[j.name]];
            });
          });
          // 转换指标名称为中文
          selectedList.value = selectedList.value.map(item => enToZh[item] || item);
          arr = arr.map(item => {
            return {
              ...item,
              name: enToZh[item.name] || item.name
            };
          });
          seriesData.value = arr;
          // 在下一个 tick 更新图表
          nextTick(() => {
            createChart();
          });
        }
      },
      // 切换货币类型（美元/人民币）
      changeRadio = () => {
        if (currency.value === 1) {
          targetList.value = targetListUsd;
        } else {
          targetList.value = targetListCny;
        }
        // 默认选择前两个指标
        targetValue.value = targetList.value.slice(0, 2).map(item => item.value);
        getData();
      },
      // 切换图表类型（趋势图/堆积图）
      changeType = index => {
        echartType.value = index;
        getData();
      },
      // 切换分组维度
      changeGroup = values => {
        groupValue.value = values;
        getData(searchForm.value);
      },
      // 切换目标指标时重新处理数据
      changeTarget = () => {
        handleData(echartData.value);
      };
    // 组件挂载时的初始化
    onMounted(() => {
      // 默认选择前两个指标
      targetValue.value = targetList.value.slice(0, 2).map(item => item.value);
      nextTick(() => {
        // 注释掉的resize监听器
        // window.addEventListener('resize', createChart)
      });
    });
    // 组件卸载时的清理
    onUnmounted(() => {
      // 注释掉的resize监听器清理
      // window.removeEventListener('resize', createChart)
    });
    // 暴露getData方法供父组件调用
    expose({
      getData
    });
    return (_ctx, _cache) => {
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_radio_group, {
        value: currency.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => currency.value = $event),
        name: "radioGroup",
        onChange: changeRadio
      }, {
        default: _withCtx(() => [_createVNode(_component_a_radio, {
          value: 1
        }, {
          default: _withCtx(() => [_createTextVNode("美元")]),
          _: 1
        }), _createVNode(_component_a_radio, {
          value: 2
        }, {
          default: _withCtx(() => [_createTextVNode("人民币")]),
          _: 1
        })]),
        _: 1
      }, 8, ["value"])])]), _createVNode(_component_a_spin, {
        spinning: loading.value
      }, {
        default: _withCtx(() => {
          var _xData$value;
          return [(_xData$value = xData.value) !== null && _xData$value !== void 0 && _xData$value.length ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : (_openBlock(), _createBlock(Empty, {
            key: 1
          }))];
        }),
        _: 1
      }, 8, ["spinning"])]);
    };
  }
});